import { render, staticRenderFns } from "./EmployeePFSlipDetails.vue?vue&type=template&id=e9635b58&scoped=true"
import script from "./EmployeePFSlipDetails.vue?vue&type=script&lang=js"
export * from "./EmployeePFSlipDetails.vue?vue&type=script&lang=js"
import style0 from "./EmployeePFSlipDetails.vue?vue&type=style&index=0&id=e9635b58&prod&scoped=true&lang=css"
import style1 from "./EmployeePFSlipDetails.vue?vue&type=style&index=1&id=e9635b58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9635b58",
  null
  
)

export default component.exports